// extracted by mini-css-extract-plugin
export default {"form_other":"passwordForgot_form_other__p9FfT","remembered":"passwordForgot_remembered__ER-yB"};